// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Page wrapper ── */
.cd-page {
  display: flex;
  justify-content: center;
  padding: 24px 16px 64px;
  min-height: 100%;
}

.cd-container {
  width: 100%;
  max-width: 640px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Back button ── */
.cd-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #9aa3ad;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
  width: fit-content;
  transition: color 0.15s ease;
}
.cd-back:hover { color: #48D1CC; }

/* ── Hero card ── */
.cd-hero {
  background: #0e1b1b;
  border-radius: 20px;
  border: 1.5px solid #484848;
  padding: 28px 24px;
  display: flex;
  gap: 20px;
  align-items: center;
}

.cd-hero-skeleton {
  min-height: 140px;
}

.cd-badge-icon {
  width: 96px;
  height: 96px;
  min-width: 96px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cd-hero-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cd-hero-name-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex-wrap: wrap;
}

.cd-cert-name {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.3;
}

.cd-expired-pill {
  font-size: 11px;
  font-weight: 700;
  background: rgba(255, 167, 38, 0.12);
  color: #ffa726;
  border-radius: 20px;
  padding: 3px 10px;
  white-space: nowrap;
  align-self: center;
}

.cd-badge-level {
  font-size: 13px;
  font-weight: 600;
}

/* ── Info card ── */
.cd-info-card {
  background: #0e1b1b;
  border-radius: 18px;
  border: 1px solid #484848;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cd-info-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
}

.cd-info-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cd-info-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #071414;
  border-radius: 12px;
  padding: 14px;
}

.cd-info-icon-wrap {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 10px;
  background: #484848;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cd-info-icon {
  color: #9aa3ad !important;
  font-size: 18px !important;
}

.cd-info-label {
  font-size: 12px;
  color: #64707d;
  margin-bottom: 3px;
}

.cd-info-value {
  font-size: 15px;
  font-weight: 600;
  color: #e6eaef;
}

.cd-mono {
  font-family: monospace;
  font-size: 14px;
  letter-spacing: 0.03em;
}

.cd-score {
  font-size: 22px;
  font-weight: 800;
}

.cd-expired-tag {
  font-size: 12px;
  font-weight: 600;
  color: #ffa726;
}

/* ── Download button ── */
.cd-btn-download {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 24px;
  border-radius: 14px;
  border: none;
  background: linear-gradient(135deg, #3BB3AE, #0099a8);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.cd-btn-download:not(:disabled):hover {
  opacity: 0.88;
  transform: translateY(-1px);
}

.cd-btn-download:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ── Skeletons ── */
.cd-skeleton {
  border-radius: 10px;
  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);
  background-size: 200% 100%;
  animation: cdSkeleton 1.4s ease infinite;
}

.cd-skel-back       { width: 140px; height: 18px; border-radius: 6px; }
.cd-skel-badge-lg   { width: 96px; height: 96px; min-width: 96px; border-radius: 24px; }
.cd-skel-hero-text  { flex: 1 1; display: flex; flex-direction: column; gap: 10px; }
.cd-skel-title-lg   { width: 65%; height: 22px; }
.cd-skel-sub        { width: 80%; height: 14px; }
.cd-skel-sub-short  { width: 45%; }
.cd-skel-info       { width: 100%; height: 200px; border-radius: 18px; }
.cd-skel-btn        { width: 100%; height: 52px; border-radius: 14px; }

@keyframes cdSkeleton {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Responsive ── */
@media (max-width: 600px) {
  .cd-hero { flex-direction: column; align-items: flex-start; }
  .cd-badge-icon { width: 72px; height: 72px; min-width: 72px; }
  .cd-cert-name { font-size: 18px; }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Certifications/CertificateDetail/CertificateDetail.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,4BAA4B;AAC9B;AACA,iBAAiB,cAAc,EAAE;;AAEjC,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yEAAyE;EACzE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,sBAAsB,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACtE,sBAAsB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACvF,sBAAsB,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACjF,sBAAsB,UAAU,EAAE,YAAY,EAAE;AAChD,sBAAsB,UAAU,EAAE,YAAY,EAAE;AAChD,sBAAsB,UAAU,EAAE;AAClC,sBAAsB,WAAW,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACvE,sBAAsB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;;AAEtE;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,qBAAqB;AACrB;EACE,WAAW,sBAAsB,EAAE,uBAAuB,EAAE;EAC5D,iBAAiB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;EAC7D,gBAAgB,eAAe,EAAE;AACnC","sourcesContent":["/* ── Page wrapper ── */\n.cd-page {\n  display: flex;\n  justify-content: center;\n  padding: 24px 16px 64px;\n  min-height: 100%;\n}\n\n.cd-container {\n  width: 100%;\n  max-width: 640px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ── Back button ── */\n.cd-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  color: #9aa3ad;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0;\n  width: fit-content;\n  transition: color 0.15s ease;\n}\n.cd-back:hover { color: #48D1CC; }\n\n/* ── Hero card ── */\n.cd-hero {\n  background: #0e1b1b;\n  border-radius: 20px;\n  border: 1.5px solid #484848;\n  padding: 28px 24px;\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.cd-hero-skeleton {\n  min-height: 140px;\n}\n\n.cd-badge-icon {\n  width: 96px;\n  height: 96px;\n  min-width: 96px;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cd-hero-body {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.cd-hero-name-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.cd-cert-name {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1.3;\n}\n\n.cd-expired-pill {\n  font-size: 11px;\n  font-weight: 700;\n  background: rgba(255, 167, 38, 0.12);\n  color: #ffa726;\n  border-radius: 20px;\n  padding: 3px 10px;\n  white-space: nowrap;\n  align-self: center;\n}\n\n.cd-badge-level {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n/* ── Info card ── */\n.cd-info-card {\n  background: #0e1b1b;\n  border-radius: 18px;\n  border: 1px solid #484848;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.cd-info-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.cd-info-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.cd-info-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  background: #071414;\n  border-radius: 12px;\n  padding: 14px;\n}\n\n.cd-info-icon-wrap {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  border-radius: 10px;\n  background: #484848;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cd-info-icon {\n  color: #9aa3ad !important;\n  font-size: 18px !important;\n}\n\n.cd-info-label {\n  font-size: 12px;\n  color: #64707d;\n  margin-bottom: 3px;\n}\n\n.cd-info-value {\n  font-size: 15px;\n  font-weight: 600;\n  color: #e6eaef;\n}\n\n.cd-mono {\n  font-family: monospace;\n  font-size: 14px;\n  letter-spacing: 0.03em;\n}\n\n.cd-score {\n  font-size: 22px;\n  font-weight: 800;\n}\n\n.cd-expired-tag {\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffa726;\n}\n\n/* ── Download button ── */\n.cd-btn-download {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 14px 24px;\n  border-radius: 14px;\n  border: none;\n  background: linear-gradient(135deg, #3BB3AE, #0099a8);\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n.cd-btn-download:not(:disabled):hover {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n.cd-btn-download:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ── Skeletons ── */\n.cd-skeleton {\n  border-radius: 10px;\n  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);\n  background-size: 200% 100%;\n  animation: cdSkeleton 1.4s ease infinite;\n}\n\n.cd-skel-back       { width: 140px; height: 18px; border-radius: 6px; }\n.cd-skel-badge-lg   { width: 96px; height: 96px; min-width: 96px; border-radius: 24px; }\n.cd-skel-hero-text  { flex: 1; display: flex; flex-direction: column; gap: 10px; }\n.cd-skel-title-lg   { width: 65%; height: 22px; }\n.cd-skel-sub        { width: 80%; height: 14px; }\n.cd-skel-sub-short  { width: 45%; }\n.cd-skel-info       { width: 100%; height: 200px; border-radius: 18px; }\n.cd-skel-btn        { width: 100%; height: 52px; border-radius: 14px; }\n\n@keyframes cdSkeleton {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ── Responsive ── */\n@media (max-width: 600px) {\n  .cd-hero { flex-direction: column; align-items: flex-start; }\n  .cd-badge-icon { width: 72px; height: 72px; min-width: 72px; }\n  .cd-cert-name { font-size: 18px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
